/**
 * Shared form styling constants (from DESIGN_SYSTEM.md).
 *
 * Import this instead of duplicating inline class strings across pages.
 */

/** Standard input/select element classes matching the design system. */
export const inputClass =
  'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';
